<template>
  <div>
    <div class="d-flex mb-3 align-items-end">
      <h1 class="h4 primary--text">
        {{ $t('views.settlement_report.settlement_report') }}
      </h1>
      <div class="ml-auto">
        <v-btn
          outlined
          large
          @click="toggleFilter"
        >
          <v-icon left>
            mdi-filter-variant
          </v-icon>
          {{ $t('common.filter') }}
        </v-btn>
      </div>
    </div>
    <settlement-report-filter
      v-model="isFilterShown"
      :filter="filter"
      @applyFilter="applyFilter"
    />
    <v-data-table
      fixed-header
      :headers="headers"
      :items="items"
      :footer-props="{
        itemsPerPageOptions: [10, 20, 50, 100],
      }"
      :options.sync="options"
      :server-items-length="total"
      :loading="loading"
      :loading-text="$t('common.loading_data')"
    />
  </div>
</template>

<script>
import SettlementReportFilter from '@/components/reports/SettlementReportFilter';

export default {
  name: 'SettlementReport',

  components: {
    SettlementReportFilter,
  },

  data() {
    return {
      items: [],
      options: {
        page: 1,
      },
      total: 0,
      loading: false,

      headers: [
        { text: this.$t('views.settlement_report.document_type'), value: 'documentType' },
        { text: this.$t('views.settlement_report.document_number'), value: 'documentNumber' },
        { text: this.$t('common.orders.creation_date'), value: 'documentDate' },
        { text: this.$t('views.settlement_report.initial_balance'), value: 'initialBalance' },
        { text: this.$t('views.settlement_report.debt_increase'), value: 'debtIncrease' },
        { text: this.$t('views.settlement_report.debt_reduce'), value: 'debtReduce' },
        { text: this.$t('views.settlement_report.final_balance'), value: 'finalBalance' },
        { text: this.$t('views.settlement_report.final_debt'), value: 'finalDebt' },
      ],

      filter: {
        startDate: '',
        endDate: '',
        documentNumber: '',
      },
      isFilterShown: false,
    };
  },

  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true,
    },
  },

  methods: {
    async getItems() {
      this.loading = true;

      const {
        sortBy, sortDesc, page, itemsPerPage,
      } = this.options;

      const filter = this.mapFilter();

      const params = {
        query: filter,
        pageSize: itemsPerPage,
        page,
      };

      if (sortBy.length) {
        params.sort = `${sortDesc[0] ? '-' : ''}${sortBy[0]}`;
      }

      try {
        const { data } = await this.$http.get('settlement-report', { params });
        this.items = data.rows.map((item) => ({
          ...item,
          documentDate: this.$moment(item.documentDate).format('L LT'),
        }));
        this.total = data.total;
      } finally {
        this.loading = false;
      }
    },

    toggleFilter() {
      this.isFilterShown = !this.isFilterShown;
    },

    applyFilter(filter) {
      this.filter = { ...filter };
      this.options.page = 1;
      this.getItems();
    },

    mapFilter() {
      const filter = {};

      if (this.filter.startDate || this.filter.endDate) {
        filter.documentDate = {};
      }
      if (this.filter.startDate) {
        filter.documentDate.$gte = this.$moment(this.filter.startDate, 'L');
      }
      if (this.filter.endDate) {
        filter.documentDate.$lte = this.$moment(this.filter.endDate, 'L').endOf('day');
      }
      if (this.filter.documentNumber) {
        filter.documentNumber = {
          $regex: `.*${this.filter.documentNumber}.*`,
          $options: 'i',
        };
      }

      return filter;
    },
  },
};
</script>
